"use strict";exports.socialProfileType={facebook:"Facebook",instagram:"Instagram",linkedin:"LinkedIn",twitter:"Twitter",youtube:"YouTube"};
